import { Stack } from "@mantine/core"
import { InfoBox } from "@tfg/ui"

import { ComponentsEditorPage } from "~/pages/Brand/CommunicationStudio/Content/ComponentsEditorPage"
import { ComponentCreationProvider } from "~/pages/Brand/CommunicationStudio/contexts/componentCreation/ComponentCreationContext"
import { useProductSheetGroup } from "~/pages/Brand/CommunicationStudio/contexts/productSheetGroup/useProductSheetGroup"

export const Components = () => {
  const { selectedProductSheetGroup } = useProductSheetGroup()
  if (!selectedProductSheetGroup) {
    return (
      <InfoBox
        title="No product sheet group selected"
        message="Please select a product sheet group"
      />
    )
  }
  return (
    <Stack gap="sm">
      <ComponentCreationProvider
        productSheetGroupId={selectedProductSheetGroup.id}
      >
        <ComponentsEditorPage />
      </ComponentCreationProvider>
    </Stack>
  )
}
